export const formatAMPM = (timeString, short = false) => {
  const timeSplit = timeString.split(":");
  var hours = parseInt(timeSplit[0]);
  var minutes = parseInt(timeSplit[1]);
  var ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  // var strTime = hours + ":" + short && minutes === 0 ? "" : minutes + ampm;
  var strTime = `${hours}${
    short && minutes === "00" ? "" : `:${minutes}`
  }${ampm}`;
  return strTime;
};

export const availabilityRangeOptions = (start, end, increment = 15) => {
  const times = [];
  // Start hour + minute
  let startTime = splitTime(start);
  // End hour + minute
  let endTime = splitTime(end);
  // Increment hours

  let startMinute = startTime.minute,
    endMinute = 60;

  for (var i = startTime.hour; i <= endTime.hour; i++) {
    if (i === endTime.hour) {
      endMinute = endTime.minute;
    }
    for (var m = startMinute; m < endMinute; m += increment) {
      let minute = formatNumber(m);
      times.push({
        military: `${formatNumber(i)}:${minute}`,
        regular: `${i === 0 || i === 12 ? 12 : i % 12}:${minute}${
          i >= 12 ? "pm" : "am"
        }`,
      });
    }
  }

  return times;
};

const formatNumber = (num) => {
  return num < 10 ? `0${num}` : num;
};

export const splitTime = (time) => {
  let parts = time.split(":");
  let hour = parseInt(parts[0]),
    minute = parseInt(parts[1]);
  return { hour: hour, minute: minute };
};
